import axios from 'axios'
// import store from '@/store'
// import storage from 'store'
// import notification from 'ant-design-vue/es/notification'
import vuex from '@/store'
import i18n from '@/common/i18n/i18n'
import { Modal } from 'ant-design-vue'

// 创建 axios 实例
const request = axios.create({
  // API 请求的默认前缀
  baseURL: '',
  headers: {
    loading: true,
    isHideError: false
  },
  // withCredentials: true,
  timeout: 60000 // 请求超时时间
})

// 异常拦截处理器
const errorHandler = (error) => {
  const index = loadingUrls.indexOf(error.config.url)
  if (index !== -1) {
    loadingUrls.splice(index, 1)
  }
  if (loadingUrls.length === 0 && !vuex.state.handLoading) {
    vuex.commit('setGlobalLoading', false)
  }
  if (error.response.config.headers.isHideError) {
    return Promise.resolve()
  }
  if (error.response) {
    // const data = error.response.data
    // 从 localstorage 获取 token
    // const token = storage.get(ACCESS_TOKEN)
    /* if (error.response.status === 403) {
      notification.error({
        message: 'Forbidden',
        description: data.message
      })
    } else if (error.response.status === 401 && !(data.result && data.result.isLogin) && !error.response.config.url.includes('/api/user/login')) {
      notification.error({
        message: 'Unauthorized',
        description: 'Authorization verification failed'
      })
    } else */
    if (error.response.status === 500) {
      Modal.error({
        title: i18n.tc('systemError'),
        closable: true,
        okText: i18n.tc('app-btn-confirm'),
        class: 'maxQuantityBox'
      })
    }
  } else {
    Modal.error({
      title: i18n.tc('systemError'),
      closable: true,
      okText: i18n.tc('app-btn-confirm'),
      class: 'maxQuantityBox'
    })
  }
  return Promise.reject(error)
}

/* 改用vuex变量 */
const loadingUrls = []

// 请求拦截器
request.interceptors.request.use(config => {
  /* 改用vuex */
  if (config.headers.loading) {
    if (loadingUrls.length === 0) {
      // open loading
      vuex.commit('setGlobalLoading', true)
    }
    loadingUrls.push(config.url)
  }
  const lang = i18n.locale === 'zh_HK' ? 'zh_TW' : i18n.locale
  config.headers['Accept-Language'] = lang
  return config
})

// response interceptor
request.interceptors.response.use((response) => {
  const index = loadingUrls.indexOf(response.config.url)
  if (index !== -1) {
    loadingUrls.splice(index, 1)
  }
  if (loadingUrls.length === 0 && !vuex.state.handLoading) {
    vuex.commit('setGlobalLoading', false)
  }
  if (response.data.errors &&
      response.data.errors.length > 0 &&
      response.config.url.startsWith(process.env.VUE_APP_MELCO_API_BASE_URL) &&
      !response.config.headers.isHideError
  ) {
    Modal.error({
      title: response.data.errors.map(item => item.message).join('\n'),
      closable: true,
      okText: i18n.tc('app-btn-confirm'),
      class: 'maxQuantityBox'
    })
    return Promise.reject(response.data)
  }
  return response.data
}, errorHandler)

export default request

export {
  request as axios
}
